import IframeResizer from 'iframe-resizer-react'
import styled from 'styled-components'

export const IFrame = styled(IframeResizer)`
    border: 0 none;
    min-height: 700px;
`
